function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNft = function SvgNft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 256 256"
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fillRule: "nonzero",
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 90a6.07 6.07 0 0 1-3.035-.81L8.248 69.723a6.09 6.09 0 0 1-3.035-5.257V25.534a6.09 6.09 0 0 1 3.035-5.257L41.965.811a6.09 6.09 0 0 1 6.071 0l33.716 19.466a6.09 6.09 0 0 1 3.035 5.257v38.932a6.09 6.09 0 0 1-3.036 5.257L48.035 89.19c-.936.54-1.986.81-3.035.81m0-86.001c-.358 0-.716.092-1.035.276L10.248 23.741a2.08 2.08 0 0 0-1.035 1.793v38.932c0 .737.397 1.424 1.034 1.792l33.717 19.467a2.08 2.08 0 0 0 2.071 0L79.75 66.258a2.07 2.07 0 0 0 1.035-1.792V25.534c0-.737-.397-1.424-1.035-1.793L46.035 4.275A2.07 2.07 0 0 0 45 3.999",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.964 1.964)scale(2.8008)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.863 57.711a2 2 0 0 1-1.699-.945l-9.597-15.461v14.407a2 2 0 0 1-4 0V34.289a2 2 0 0 1 3.7-1.054l9.597 15.461V34.289a2 2 0 0 1 4 0v21.422a2 2 0 0 1-2.001 2M42.17 57.711a2 2 0 0 1-2-2V34.289a2 2 0 0 1 2-2h8.519a2 2 0 0 1 0 4H44.17v19.422a2 2 0 0 1-2 2",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.964 1.964)scale(2.8008)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.689 47H42.17a2 2 0 0 1 0-4h8.519a2 2 0 0 1 0 4M69.433 36.289H57.259a2 2 0 0 1 0-4h12.175a2 2 0 1 1-.001 4",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.964 1.964)scale(2.8008)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.346 57.711a2 2 0 0 1-2-2V34.289a2 2 0 0 1 4 0v21.422a2 2 0 0 1-2 2",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.964 1.964)scale(2.8008)"
  })));
};
export { SvgNft as ReactComponent };